import { BOARD_SIZE } from '../gameConstants';

// 8 directions: right, down-right, down, down-left, left, up-left, up, up-right
export const DIRECTIONS = [
    [0, 1],
    [1, 1],
    [1, 0],
    [1, -1],
    [0, -1],
    [-1, -1],
    [-1, 0],
    [-1, 1],
];

export function isInBounds(row, col) {
    return row >= 0 && row < BOARD_SIZE && col >= 0 && col < BOARD_SIZE;
}

export function walkPath(board, startRow, startCol, dirIndex, steps, ignoreValues = []) {
    const [dr, dc] = DIRECTIONS[dirIndex];
    let r = startRow + dr;
    let c = startCol + dc;

    for (let step = 0; step < steps; step++) {
        if (!isInBounds(r, c)) return null;
        if (!ignoreValues.includes(board[r][c])) return null;
        if (step < steps - 1) {
            r += dr;
            c += dc;
        }
    }
    return { row: r, col: c };
}

export function getValidMovesForPiece(board, row, col, steps) {
    const moves = [];
    for (let d = 0; d < 8; d++) {
        const dest = walkPath(board, row, col, d, steps, [0]);
        if (dest) moves.push(dest);
    }
    return moves;
}

export function hasAnyValidMove(board, player, steps) {
    for (let r = 0; r < BOARD_SIZE; r++) {
        for (let c = 0; c < BOARD_SIZE; c++) {
            if (board[r][c] === player) {
                if (getValidMovesForPiece(board, r, c, steps).length > 0) {
                    return true;
                }
            }
        }
    }
    return false;
}

export function checkForWinner(board) {
    for (let r = 0; r < BOARD_SIZE; r++) {
        for (let c = 0; c < BOARD_SIZE; c++) {
            const piece = board[r][c];
            if (piece === 0 || piece === 10) continue;

            for (let d = 0; d < 8; d++) {
                const [dr, dc] = DIRECTIONS[d];
                let count = 1;
                let nr = r + dr;
                let nc = c + dc;

                while (isInBounds(nr, nc) && board[nr][nc] === piece) {
                    count++;
                    nr += dr;
                    nc += dc;
                }

                if (count >= 5) {
                    const winningCells = [];
                    let wr = r;
                    let wc = c;
                    for (let i = 0; i < count; i++) {
                        winningCells.push([wr, wc]);
                        wr += dr;
                        wc += dc;
                    }
                    return { winner: piece, cells: winningCells };
                }
            }
        }
    }
    return null;
}
